import IconButton from 'LuxKit/Button/IconButton'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'
import Caption from 'LuxKit/Typography/Caption'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { useAppDispatch } from 'hooks/reduxHooks'
import { pushWithRegion } from 'actions/NavigationActions'
import { useSelector } from '@xstate/react'
import { MultiCartContext } from 'machines/cart/MultiCartMachineProvider'
import { selectItemsInActiveVisibleCart } from 'machines/cart/selectors'
import { isDisplayableMultiCartItem } from 'components/Pages/UserCartPage/SharedCarts/multiCartUtils'

const StyledNotificationIconButton = styled(IconButton)`
  position: relative;
`

const RedDotOnSignUp = styled(Caption)`
  position: absolute;
  top: ${rem(2)};
  right: ${rem(2)};
  padding: ${rem(2)} ${rem(4)};
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.messaging.critical.normalBackground};
  color: ${props => props.theme.palette.messaging.critical.normalContrast};
`

function MultiCartHeader() {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const overflowLabel = intl.formatMessage({
    id: 'vM6Mzc1tmNUz3_ZAhlXu',
    defaultMessage: '9+',
    description: 'Badge count text when cart has more than 9 items in the shopping cart',
  })

  const onClickCart = useCallback(() => {
    dispatch(pushWithRegion('/cart'))
  }, [dispatch])

  const multiCartActorRef = MultiCartContext.useActorRef()
  const cartItems = useSelector(multiCartActorRef, (snapshot) => {
    return selectItemsInActiveVisibleCart(snapshot)
      .filter(item => isDisplayableMultiCartItem(item) && item.state === 'active' && item.status === 'available').length
  })

  return <StyledNotificationIconButton
    kind="tertiary"
    variant="default"
    role="menuitem"
    onClick={onClickCart}
  >
    <LineShoppingCartIcon />
    {cartItems > 0 && <RedDotOnSignUp variant="small">
      {cartItems > 9 ? overflowLabel : cartItems}
    </RedDotOnSignUp>}
  </StyledNotificationIconButton>
}

export default MultiCartHeader
